import { render, staticRenderFns } from "./TaskRelatedSubject.vue?vue&type=template&id=24273c76"
import script from "./TaskRelatedSubject.vue?vue&type=script&lang=ts"
export * from "./TaskRelatedSubject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports